module.exports = __webpack_public_path__ + "img/20170704_135648_098.e81b2c61.jpg";